export const showErrorPage = (message) => {
  throw createError({
    message,
    fatal: true,
  })
}
